module.exports = __webpack_public_path__ + "img/phone.81ce6138.svg";